import { formatNumber } from "accounting"
import { Flex, Typography } from "antd"
import dayjs from "dayjs"

import Private from "../../../../Components/Private"
import Icon from "../../../../Icon"
import { dateFormat } from "../../../../Utils/utils"
import ChannelTag from "../../../DeflectAnalyticsPage/components/ChannelTag"
import { PROGRAM_CARD_META } from "../../constants/receipt-status-mapping"

import styles from "./styles.module.less"

const { Text } = Typography

// `renderDetails` adds a row of the caller's own between the card and the channel rows: the
// Analytics Recent lookups card shows the descriptor and the result there, the Receipt list does not.
const ReceiptLookupCard = ({ record, renderDetails }) => {
  const program = PROGRAM_CARD_META[record.program]

  return (
    <Flex
      vertical
      gap={8}
      className={styles.card}
      data-testid={`deflect-user-lookup-card-${record.id}`}
    >
      <Flex justify="space-between" align="center">
        <Text strong>{dayjs(record.date).format(dateFormat)}</Text>
        {program && (
          <Flex justify={"center"} align="center" gap={4}>
            {program?.iconType && <Icon type={program.iconType} className={styles.icon} />}
            <Text strong>{program?.label}</Text>
          </Flex>
        )}
      </Flex>
      <Flex justify="space-between" align="center">
        <Text type="secondary">{record.card ? <Private>{record.card}</Private> : "—"}</Text>
        <Text strong>
          <Private>${formatNumber(record.amount ?? 0, 2, ",")}</Private>
        </Text>
      </Flex>
      {renderDetails?.(record)}
      <Flex justify="space-between" align="center">
        <ChannelTag value={record.channel} />
        <Text type="secondary" style={{ fontSize: 12 }}>
          Fee <Private>${formatNumber(record.fee_charged ?? 0, 2, ",")}</Private>
        </Text>
      </Flex>
    </Flex>
  )
}

export default ReceiptLookupCard
